export default {
  // Profile
  orgId: 'Org ID',
  memberName: 'Member Name',
  corporateName: 'Company Name',
  loginId: 'ID',
  administratorName: 'Primary Admin Name',
  administratorPhoneNumber: 'Primary Admin Number',
  memberRegistrationDate: 'Sign-up Date',
  serviceType: 'Service Type',
  currentPassword: 'Current Password',
  newPassword: 'New Password',
  passwordFormatErrorContent: 'Invalid password format.',
  passwordMatchErrorContent: 'The new password does not match.',
  currentPasswordMatchErrorContent: 'The current password is incorrect.',
  updatePasswordSuccessContent: 'Password update completed.',
  profileCaption: '* To edit member information, please contact your sales representative or submit a 1:1 inquiry.',
  passwordChange: 'Change Password',
  att: 'FriendTalk',
  ftt: 'AlimTalk',
  unsubscribe: 'Unsubscribe Settings',
  adUnsubscribe: 'Unsubscribe from Promotional Messages',
  informationUnsubscribe: 'Unsubscribe from Informational Messages',
  passwordCaption: 'The password must be at least 10 characters and include at least two of the following: letters, numbers, and special characters.',
  changeBtn: 'Update',
  confirmNewPassword: 'Confirm Password',
  memberLastLoginDate: 'Last Login',
};
